import Header from './Header';

export default Header;



// WEBPACK FOOTER //
// ./src/components/grids/SolicitationsGrid/subcomponents/Header/index.jsx